import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../generalSuccessPopup/generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useEffect, useRef, useState } from "react";
import { formatCountdown, WARNING_DURATION } from "../../../utils/constants";

function InactivityWarningPopup({ onClose }: IPopupWithoutProps) {
  const [countdown, setCountdown] = useState(WARNING_DURATION / 1000);
  const channelRef = useRef<BroadcastChannel | null>(null);

  useEffect(() => {
    // Create channel to communicate with other tabs
    channelRef.current = new BroadcastChannel('user_activity');

    let countdownInterval: NodeJS.Timeout;
    countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
      channelRef.current?.close();
    };
  }, []);

  const handleClose = () => {
    // Notify all tabs that warning was dismissed
    channelRef.current?.postMessage({ type: 'warning_dismissed' });
    onClose();
  };

  return (
    <article className={popupStyles.popup}>
      <img
        src={doctor}
        alt={t("IMAGE_OF_VENUS")}
        className={popupStyles.popup__img}
      />
      <p className={`${popupStyles.popup__title} ${popupStyles.popup__title_small}`}>
        {t("INACTIVITY_NOTICE")}
      </p>
      <p className={popupStyles.popup__text}>
        {t("SECURITY_AND_PRIVACY_EXIT")}{" "}
        <span>{formatCountdown(countdown)}</span>
      </p>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={handleClose}
      >
        {t("KEEP_ME_HERE")}
      </button>
    </article>
  );
}
export default InactivityWarningPopup;
